<template>
  <div class="page-section">
    <h1 class="info-title">Looking for <b>expert advice?</b></h1>

    <div class="section-subtitle">
      <b>
        Explore our directory of trusted professionals — from lawyers, mortgages and insurance to savings and pensions.
      </b>
    </div>

    <button class="light-blue-button" @click="handleButtonClick">
      Book a free consultation <span class="arrow-right">→</span>
      </button>
  </div>
</template>

<script setup>

const emit = defineEmits(['buttonClick']);

const handleButtonClick = () => {
  emit('buttonClick');
};

</script>

<style lang="scss" scoped>
@import "../../../../scss/riseup-vars";

.page-section {
  background-color: #205441;
  color: #202125;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding-bottom: 65px;
}

.info-title {
  font-size: 34px;
  color: #FFFFFF;
  padding-top: 15px;
  padding-right: 25px;
  margin-bottom: 20px;
  text-align: left;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  font-weight: 100 !important;
  line-height: 1;
}

.info-title b {
  font-weight: 900 !important;
}

.section-subtitle {
  font-size: 17px;
  margin-top: 25px;
  margin-bottom: 40px;
  color: #FFFFFF;
  text-align: left;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.5;
}

.light-blue-button {
  background: #5D7AFD;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 8px 16px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  color: white;
  padding: 17px 0px;
  border: none;
  width: 100%;
  cursor: pointer;
  font-size: 18px;
  font-weight: 700;
  margin-top: 15px;
  margin-bottom: 10px;
  margin-left: auto;
  margin-right: auto;
  display: block;
  padding-top: 16px;
  padding-bottom: 18px;
  width: 80%;
}
</style>
